import * as Dialog from "@radix-ui/react-dialog";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useResponsive } from "@/hooks/useResponsive";
import { useNotShowMobileWarning } from "@/stores/notShowMobileWarningAtom";

export const MobileWarningModal = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [notShowMobileWarning, setNotShowMobileWarning] =
    useNotShowMobileWarning();

  const handleClose = () => {
    setNotShowMobileWarning(true);
  };

  return (
    <Dialog.Root open={isMobile && !notShowMobileWarning}>
      <Dialog.Portal>
        {/* オーバーレイ */}
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" />

        {/* モーダルコンテンツ */}
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-lg">
          <Dialog.Title className="mb-2 text-base font-medium text-black">
            {t("mobile.warning.title")}
          </Dialog.Title>

          <Dialog.Description className="text-sm leading-relaxed text-black/70">
            {t("mobile.warning.description.line1")}
            <br />
            <br />
            {t("mobile.warning.description.line2")}
          </Dialog.Description>

          <div className="mt-6 flex justify-center">
            <Button onClick={handleClose} size="sm">
              {t("common.close")}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
